// extracted by mini-css-extract-plugin
export default {"container":"BF-z","modal":"CF-z","dimensions":"DF-z","brandName":"EF-z","productName":"FF-z","labelValue":"GF-z","recipientEmail":"HF-z","recommendedFit":"IF-z","hiddenField":"JF-z"};